import React from 'react';
import { Link } from 'react-router-dom';
import { generateProductUrlFromData } from '../../services/urlService';

const ListView = ({ products, selectedColors, handleColorSelect, getSelectedColor, getImageForProduct, collections }) => {
  // Color Palette Component for List View
  const ColorPalette = ({ productId, productColors, product }) => {
    const selectedColorId = getSelectedColor(productId);
    const isOutOfStock = (colorId) => product.outOfStockColors?.includes(colorId);

    return (
      <div className="color-palette list">
        {productColors.map(color => (
          <div
            key={color.id}
            className={`color-option ${selectedColorId === color.id ? 'selected' : ''} ${isOutOfStock(color.id) ? 'out-of-stock' : ''}`}
            style={{
              backgroundColor: color.hex,
              position: 'relative'
            }}
            title={`${color.label}${isOutOfStock(color.id) ? ' (Rupture de Stock)' : ''}`}
            onClick={() => !isOutOfStock(color.id) && handleColorSelect(productId, color.id)}
          >
            {isOutOfStock(color.id) && (
              <span style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: '120%',
                height: '2px',
                backgroundColor: 'rgba(100, 100, 100, 0.7)',
                transform: 'translate(-50%, -50%) rotate(-45deg)',
                pointerEvents: 'none'
              }} />
            )}
          </div>
        ))}
      </div>
    );
  };

  // Helper function to get collection name
  const getCollectionName = (product) => {
    if (!product.collectionId || !collections || collections.length === 0) return null;
    const collection = collections.find(c => c._id === product.collectionId);
    return collection ? collection.name : null;
  };

  // Helper function to generate product URL
  const getProductUrl = (product) => {
    if (!product || !product.name) return '/shop-details';

    // Find the collection for this product
    const collection = collections?.find(c => c._id === product.collectionId);

    if (collection) {
      return generateProductUrlFromData(product, collection);
    }

    // Fallback to old URL format if collection not found
    return '/shop-details';
  };

  return (
    <div className="row">
      {products.map((item) => (
        <div key={item.id} className="col-lg-12">
          <div className="shop-item mb-40 list-view" style={item.isOutOfStock ? { opacity: 0.65, position: 'relative' } : {}}>
            <div className="shop-thumb" style={{ position: 'relative' }}>
              <Link to={getProductUrl(item)} style={{ textDecoration: 'none' }}>
                <img
                  src={getImageForProduct(item)}
                  alt={item.title}
                  style={item.isOutOfStock ? { filter: 'grayscale(100%)', opacity: 0.7 } : {}}
                />
              </Link>
              {/* Out of Stock overlay */}
              {item.isOutOfStock && (
                <>
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(255, 255, 255, 0.4)',
                    zIndex: 3,
                    borderRadius: '4px'
                  }} />
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: '#dc3545',
                    padding: '12px 24px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    zIndex: 4,
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
                    whiteSpace: 'nowrap',
                    backgroundColor: 'transparent'
                  }}>
                    Rupture de Stock
                  </div>
                </>
              )}
            </div>
            <div className="shop-content list-view">
              <div>
                {getCollectionName(item) && (
                  <span className="collection-name">{getCollectionName(item)}</span>
                )}
                <span>{item.category}</span>
                <h4 className="title"><Link to={getProductUrl(item)}>{item.title}</Link></h4>
                <p className="mb-20 description">Trouvez votre compagnon idéal avec notre sélection de haute qualité.</p>
                {/* Color palette for list view - under text, before add button */}
                {item.colors && item.colors.length > 1 && (
                  <div className="color-palette-container">
                    <ColorPalette
                      productId={item.id}
                      product={item}
                      productColors={item.colors}
                    />
                  </div>
                )}
              </div>
              <div className="shop-content-bottom">
                <span className="price">{item.price}</span>
                <span className="add-cart"><Link to={getProductUrl(item)}>Voir Détails</Link></span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListView;